
<script lang="ts">
    import { createEventDispatcher, onMount } from "svelte";
    import { Logout, me } from "./user";
    import { push, replace } from "svelte-spa-router";
    import { formatDateTime } from "./Pages/Formats";
    import { translate, setLanguage, currentLanguage } from "./Translator";
    // import { settings } from "./settings";
    
    const dispatch = createEventDispatcher();
    
    function sidebarToggle()
    {
        dispatch('sidebartoggle');
    }
    
    function toggleLanguage() {
        currentLanguage.update(lang => {
            const newLang = lang === 'en' ? 'es' : 'en';
            
            // Dispatch event to notify other components about language change
            dispatch('languagechange', { language: newLang });
            
            return newLang;
        });
    }
    
    </script>

<style>
    .translate-button {
        background: linear-gradient(145deg, #2c3e50, #34495e);
        border: 1px solid #3498db;
        border-radius: 15px;
        color: #ecf0f1;
        padding: 6px 12px;
        font-size: 0.75em;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        gap: 6px;
        box-shadow: 0 2px 8px rgba(52, 152, 219, 0.2);
        position: relative;
        text-transform: uppercase;
        letter-spacing: 0.3px;
        min-height: 28px;
    }

    .translate-button:hover {
        background: linear-gradient(145deg, #34495e, #2c3e50);
        border-color: #2980b9;
        box-shadow: 0 3px 12px rgba(52, 152, 219, 0.3);
        transform: scale(1.02);
    }

    .translate-button:active {
        transform: scale(0.98);
        box-shadow: 0 1px 6px rgba(52, 152, 219, 0.2);
    }

    .translate-button .translate-icon {
        font-size: 0.9em;
        color: #3498db;
        transition: all 0.3s ease;
    }

    .translate-button:hover .translate-icon {
        color: #2980b9;
        transform: scale(1.1);
    }

    .language-badge {
        background: linear-gradient(135deg, #3498db, #2980b9);
        color: white;
        border-radius: 10px;
        padding: 2px 6px;
        font-size: 0.6em;
        font-weight: 700;
        letter-spacing: 0.5px;
        box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.3);
        border: 1px solid rgba(255, 255, 255, 0.2);
        min-width: 20px;
        text-align: center;
    }

    /* Efecto de pulso sutil */
    .translate-button::after {
        content: '';
        position: absolute;
        top: -1px;
        left: -1px;
        right: -1px;
        bottom: -1px;
        background: linear-gradient(45deg, #3498db, #2980b9, #3498db);
        border-radius: 16px;
        z-index: -1;
        opacity: 0;
        transition: opacity 0.3s ease;
    }

    .translate-button:hover::after {
        opacity: 0.3;
    }

    /* Hamburger menu styles */
    .hamburger-menu {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        width: 24px;
        height: 20px;
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 0;
        margin: 0;
        transition: all 0.3s ease;
    }

    .hamburger-menu:hover {
        transform: scale(1.1);
    }

    .hamburger-line {
        width: 100%;
        height: 2px;
        background-color: #ffffff;
        border-radius: 1px;
        transition: all 0.3s ease;
        transform-origin: center;
    }

    .hamburger-menu:hover .hamburger-line {
        background-color: #3498db;
    }

    /* Responsive design */
    @media (max-width: 768px) {
        .translate-button {
            padding: 5px 10px;
            font-size: 0.7em;
            min-height: 26px;
        }
        
        .language-badge {
            font-size: 0.55em;
            padding: 1px 5px;
        }

        .hamburger-menu {
            width: 22px;
            height: 18px;
            display: flex !important;
        }

        .hamburger-line {
            height: 2px;
        }
    }

    @media (max-width: 480px) {
        .hamburger-menu {
            width: 20px;
            height: 16px;
        }
    }

    /* Desktop hamburger menu - visible but not functional */
    @media (min-width: 769px) {
        .hamburger-menu {
            display: flex !important;
            opacity: 0.3;
            cursor: default;
        }

        .hamburger-menu:hover {
            transform: none;
        }

        .hamburger-menu .hamburger-line {
            background-color: rgba(255, 255, 255, 0.5);
        }
    }

    /* Hide toggle/selector elements on mobile */
    @media (max-width: 768px) {
        /* Hide center menu items that might be toggles */
        .ui.menu .center.menu .item {
            display: none !important;
        }

        /* Hide user info on mobile */
        .ui.menu .right.menu .item:has(i.user.cirlce.icon) {
            display: none !important;
        }

        /* Alternative selector for user info */
        .ui.menu .right.menu .item:last-child {
            display: none !important;
        }

        /* Hide user info with more specific selectors */
        .ui.menu .right.menu .item:has(a[href="#/User/Logout"]),
        .ui.menu .right.menu .item:has(a[href="#/user/login"]) {
            display: none !important;
        }

        /* Ensure translate button stays visible */
        .ui.menu .right.menu .item:has(.translate-button) {
            display: flex !important;
        }
    }
</style>
    
    <nav class="ui top fixed inverted menu" style="height: 3em">
        <div class="left menu">
            <div class="header sidebar-menu-toggler item hamburger-menu" on:click={(e) => {e.preventDefault(); sidebarToggle()}} >
                <div class="hamburger-line"></div>
                <div class="hamburger-line"></div>
                <div class="hamburger-line"></div>
            </div>
    
            <!-- <div class="header item">Wallet ({$settings.CashMode})</div> -->
            <div class="header item">Wallet </div>
        </div>
    
        <!-- <div class="center menu">
            {#if ShiftInProgress($shift)}
                <div class="header item">Shift #{$shift?.Id} started {formatDateTime($shift?.Start)} by {$shift?.User?.FirstName ?? ""} {$shift?.User?.LastName ?? ""} (#{$shift?.UserId ?? ""})</div>
            {:else}
                <div class="header item">No shift in progress</div>
            {/if}
        </div> -->
    
        <div class="right menu">
        
            <!-- Translate button -->
            <div class="item">
                <button class="translate-button" title="Toggle Language" on:click={toggleLanguage}>
                    <i class="translate icon translate-icon" />
                    <span class="language-badge">{$currentLanguage.toUpperCase()}</span>
                </button>
            </div>
               
            {#if $me}
                <div class="item">
                    <i class="user cirlce icon" />
                    {($me?.FirstName ?? "") + " " + ($me?.LastName ?? "")} (<a href="#/User/Logout">LOGOUT</a>)
                </div>
            {:else}
                <a href="#/user/login" class="item">
                    <i class="user cirlce icon" />
                    Login
                </a>
            {/if} 
    
                 
    
        </div>
    </nav>
    
